import React from "react";
import {
  AiFillCheckCircle,
  AiOutlineCloseCircle,
  AiOutlineFieldTime,
} from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import Button from "../../components/Button";
import Gap from "../../components/Gap";
import Loading from "../../components/Loading";
import Text from "../../components/Text";
import { proses_data, send_email } from "../../config/config";
import FETCH_API from "../../config/fetch_api";
import { baseUrl, modePayment, router } from "../../Constants";
import { formatDate } from "../../utils/formatDate";
import formatterMoney from "../../utils/formatMoney";
import { showLog } from "../../utils/log";
import { socket } from "../../utils/socket";

function TransactionProcessed2() {
  const { addToast } = useToasts();
  let navigate = useNavigate();
  const [data, setData] = React.useState();
  const [loading, setLoading] = React.useState(true);
  const [ovo, setOvo] = React.useState(false);
  const login = JSON.parse(localStorage.getItem("login"));
  const orderDate = JSON.parse(localStorage.getItem("orderDate"));
  const branch = JSON.parse(localStorage.getItem("dataBranch"));
  const alamat = JSON.parse(localStorage.getItem("alamatUsers"));
  const pickup_delivery = localStorage.getItem("pickup_delivery");
  const metode = localStorage.getItem("metode");
  let without = "";
  if (pickup_delivery == "delivery") {
    without = alamat.dataWithout;
  }

  React.useEffect(async () => {
    showLog("TransactionProcessed2 Masuk useEffect 1");
    checkStatus("1");
    // cekSuccess()
  }, []);

  async function cekSuccess(result) {
    showLog("TransactionProcessed2 Masuk cekSuccess");
    try {
      const id = JSON.parse(localStorage.getItem("idpesanan"));
      const detailData = [];
      let nomerHp = "";
      if (localStorage.getItem("login")) {
        nomerHp = login.telp;
      } else {
        nomerHp = orderDate.nomerHp;
      }
      const process = await proses_data();
      if (process.status == "Success") {
        send_email({
          subject: "Pembayaran Uruz",
          carabayar: metode,
          idTransaksi: id,
          subTotal: result.hasil.charge_amount,
          grandTotal: result.hasil.charge_amount,
          linkLihatDetail: `${baseUrl}${router}`,
          detailData: detailData,
        });
        addToast("Pembayaran Berhasil", {
          appearance: "success",
          autoDismiss: true,
        });
        checkStatus("3");
      } else {
        addToast("Maaf ada kesalahan sistem, mohon coba lagi", {
          appearance: "error",
          autoDismiss: true,
        });
        setLoading(false);
      }
      setLoading(false);
      return;
    } catch (error) {
      showLog(`Transaction Processed2 ${error}`);
    }
  }

  React.useEffect(() => {
    showLog("TransactionProcessed2 Masuk useEffect 2");
    // GojekStatus()
    // GojekUpdateStatus()

    const handleConnect = () => {
      showLog(`Socket Connected With ID = ${socket.id}`);
    };

    const handleConnectError = (err) => {
      showLog(`Socket Connect Error ${err}`);
    };

    const handlePaymentSuccess = (data) => {
      const orderDate = JSON.parse(localStorage.getItem("dataBranch"));
      const currentTransId = orderDate?.detailData;
      const incomingTransId =
        data?.trans_id ?? data?.transId ?? data?.transID ?? data?.id ?? data?.data?.trans_id;

      if (incomingTransId && currentTransId) {
        if (String(incomingTransId) !== String(currentTransId)) return;
      }

      showLog(
        `[socket:payment-success] incomingTransId=${incomingTransId} currentTransId=${currentTransId}`
      );
      checkStatus("1");
    };

    socket.on("connect", handleConnect);
    socket.on("connect_error", handleConnectError);
    socket.on("payment-success", handlePaymentSuccess);

    return () => {
      socket.off("connect", handleConnect);
      socket.off("connect_error", handleConnectError);
      socket.off("payment-success", handlePaymentSuccess);
    };
  }, []);

  async function checkStatus(params) {
    showLog("TransactionProcessed2 Masuk checkStatus");
    try {
      const userServer = JSON.parse(localStorage.getItem("userServer"));
      const id_wallet = JSON.parse(localStorage.getItem("id_wallet"));
      let nomerHp = {};
      if (login) {
        nomerHp.nomerHp = login.telp;
      } else {
        nomerHp.nomerHp = orderDate.nomerHp;
      }
      const res = await FETCH_API("payment-gateway/checkSuccessWalletXendit", {
        id: id_wallet,
        mode: modePayment,
        userServer: userServer,
        branch_id: branch?.branchID,
      });
      // const result = JSON.parse(res?.config.data)
      const result = res;
      if (result.status == "OK") {
        setData(result.hasil);
        if (params == "1") {
          if (result.hasil.channel_code == "ID_OVO") {
            setOvo(true);
            localStorage.removeItem("pesanan");
          }
        }
        if (result.hasil.status == "SUCCEEDED" && params !== "3") {
          cekSuccess(result);
          localStorage.removeItem("pesanan");
        } else {
          setLoading(false);
          if (params == "2") {
            addToast("Mohon untuk menyelesaikan pembayaran anda.", {
              appearance: "info",
              autoDismiss: true,
            });
            localStorage.removeItem("pesanan");
          }
        }
      }
    } catch (error) {
      showLog(`Transaction Processed2 ${error}`);
    }
  }

  return (
    <div style={{ position: "fixed", height: "100%", width: "100%" }}>
      <div
        onClick={() => navigate(`/${router}`)}
        style={{ margin: "10px 10px 0" }}
      >
        <AiOutlineCloseCircle size={30} color="#8B78FF" />
      </div>
      <div
        style={{
          display: "grid",
          justifyContent: "center",
          alignItems: "center",
          height: "80%",
          margin: "10px 10px 0",
        }}
      >
        {!loading ? (
          <div
            style={{
              boxShadow:
                "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
              padding: 25,
              borderRadius: 10,
            }}
          >
            <div
              style={{
                display: "grid",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {data?.status == "SUCCEEDED" ? (
                <AiFillCheckCircle size={70} color="#03B134" />
              ) : (
                <AiOutlineFieldTime size={70} color="#f0de16" />
              )}
            </div>
            <Gap height={10} />
            <div
              style={{
                display: "grid",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {data?.status == "SUCCEEDED" ? (
                <Text className="fonts700" style={{ fontSize: 15 }}>
                  Transaksi sukses
                </Text>
              ) : (
                <Text className="fonts700" style={{ fontSize: 15 }}>
                  Transaksi sedang diproses
                </Text>
              )}
            </div>
            <Gap height={20} />
            {ovo && data?.status === "SUCCEEDED" && (
              <div style={{ backgroundColor: "#8B78FF", borderRadius: 5 }}>
                <div style={{ padding: "10px 10px" }}>
                  <span className="fonts700" style={{ color: "#fff" }}>
                    Silahkan lakukan pembayaran menggunakan aplikasi OVO anda.
                  </span>
                </div>
              </div>
            )}
            <Gap height={50} />
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <Text className="fonts700">Tanggal</Text>
                {/* <Text className="fonts700" >Metode Pembayaran</Text> */}
                <Text className="fonts700">Total Pembayaran</Text>
              </div>
              <div style={{ textAlign: "end" }}>
                <Text className="fonts700">{formatDate(data?.created)}</Text>
                {/* <Text className="fonts700" >{dataPay.filter((items) => items.id == data?.channel_code)[0]?.name}</Text> */}
                <Text className="fonts700">
                  {formatterMoney(data?.charge_amount)}
                </Text>
              </div>
            </div>
            <Gap height={70} />
            <Button
              loading={loading}
              onClick={() => {
                if (data?.status !== "SUCCEEDED") {
                  setLoading(true);
                  checkStatus("2");
                } else {
                  navigate(`${router}/bill`);
                }
              }}
              backgroundColor="#5451D6"
              color="#fff"
            >
              {data?.status !== "SUCCEEDED" ? "Cek Status" : "Lihat Bill"}
            </Button>
          </div>
        ) : (
          <Loading />
        )}
      </div>
    </div>
  );
}

export default TransactionProcessed2;
